import React, { Component } from 'react';
import * as axios from 'axios';
import PropTypes from 'prop-types';
import './PeopleClient.scss';
import PeopleCard from './PeopleCard';
import AdvancedSearch from './advancedSearch';
import { Pagination } from '@material-ui/lab';
import Select from '@material-ui/core/Select';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReCAPTCHA_Modal from './reCAPTCHA';
import jQuery from 'jquery';


const endpoint = "/sites/all/modules/njit_custom/njit_people_client/workfolio.php";
const DeptEndppont = "/sites/all/modules/njit_custom/njit_people_client/workfolio.php?listDepts";
const queryParameters = new URLSearchParams(window.location.search);


class PeopleClient extends Component {

  constructor(props) {
	  
    super(props);
	this.accessTypes=['Standard Access','Assisted Access','Staff Use Only','Submit a Job'];
    this.state = {
	    page:queryParameters.get("page")?Number(queryParameters.get("page")):1,
	    pageSize:10,
		totalPage:0,
		totalResult:0,
        data: [],
		keyword : queryParameters.get("keyword"),
		advancedOpen: false,
		department: queryParameters.get("department"),
		ucid: queryParameters.get("ucid"),
		location: queryParameters.get("location"),
		phone: queryParameters.get("phone"),
		dept:{},
		page_arr:[],
		loading: false,
		sort_by: queryParameters.get("sort_by")?queryParameters.get("sort_by"):"last_name",
		user_location: null,
		token: null,
		captcha_req: false,
		captcha_display: false
    };
	this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
	this.handlePageChange = this.handlePageChange.bind(this);
	this.toggleAdvancedSearch = this.toggleAdvancedSearch.bind(this);
	this.sortByChange = this.sortByChange.bind(this);
	this.setReCAPTCHAToken = this.setReCAPTCHAToken.bind(this);
	this.onReCAPTCHAClose = this.onReCAPTCHAClose.bind(this);
	this.resetFilters = this.resetFilters.bind(this);
	this.resetDept = this.resetDept.bind(this);
  }

  //updating states as user change search input
  handleChange(event){
	var target = event.target;
	console.log(target);
	this.setState({[target.name]:target.value});

	if(target.name=='department'){
		var shownVal = document.getElementById("department").value;
		if(shownVal=="St. Michael's Med Ctr Health Svs" || shownVal=="Bursar's Office"){
			this.setState({department:shownVal});	
			return;
		}
		if(document.querySelector("#org_list option[value='"+shownVal+"']")){
			var value2send = document.querySelector("#org_list option[value='"+shownVal+"']").dataset.value;
			console.log('org:',value2send)
			this.setState({department:value2send})
		}
	}
  }

  //handling submit on search form
  handleSubmit(event){
	event.preventDefault();
	this.setState({page:1}, ()=>{
		this.searchWorkfolio();
	})
  }

  setReCAPTCHAToken({token}){
	this.setState({token: token}, ()=>{
		this.searchWorkfolio();
	})
	this.setState({captcha_display:false})
  }

  getDept(){
	axios({
		method: 'GET',
		url: DeptEndppont,
		headers: {
		'Content-Type': 'application/json'
		}
	}).then((response) => {
		console.log("dept data = " , response.data);
		this.setState({dept: response.data});
	})
	.catch((error) => {
	}); 
  }

  searchWorkfolio (){
	this.setState({loading:true});
	let paramsBody= {
		page: this.state.page,
		pageSize: this.state.pageSize,
		sort_by: this.state.sort_by,
		token: this.state.token
	};
	// keyword: this.state.keyword, 
	// department: this.state.department, 
	// ucid: this.state.ucid,
	// location: this.state.location,
	// phone: this.state.phone,

	if(this.state.keyword) paramsBody.keyword= this.state.keyword;
	if(this.state.department) paramsBody.department= this.state.department;
	if(this.state.ucid) paramsBody.ucid= this.state.ucid;
	if(this.state.location) paramsBody.location= this.state.location;
	if(this.state.phone) paramsBody.phone= this.state.phone;
	console.log(paramsBody);
		
	axios({
		method: 'POST',
		url: endpoint,
		headers: {
		'Content-Type': 'application/json'
		},
		data: JSON.stringify(paramsBody)
	}).then((response) => {
		console.log("data = " , response.data);
		this.setState({captcha_req: response.data.captcha_req}, ()=>{
			console.log('captcha:', this.state.captcha_req);
			if(this.state.captcha_req){
				this.setState({captcha_display:true})
			}
			else{
				this.setState({ data: response.data.results, totalResult: response.data.total, totalPage: Math.ceil(response.data.total/this.state.pageSize), loading:false, user_location:response.data.location});
				for(const key in paramsBody){
					if(paramsBody[`${key}`]&&key!="token"){
						queryParameters.set(`${key}`,this.state[`${key}`]);
					}
					else if(!paramsBody[`${key}`]&&queryParameters.get(`${key}`)){
						queryParameters.delete(`${key}`);
					}
				}
				window.history.replaceState(null, null, "?" + queryParameters.toString());
			}
		})
	})
	.catch((error) => {
		console.log(error)
	});   
  }

  componentDidMount() {
	if(1){
		//Load department list as datalist once when the page loads
		this.getDept();
		console.log('current page:', this.state.page);

		var hasAdvancedFilter = 0;
		if(this.state.department||this.state.ucid||this.state.phone||this.state.location){
			hasAdvancedFilter = 1;
		}

		this.setState({advancedOpen: hasAdvancedFilter},()=>{
			if(this.state.keyword||this.state.advancedOpen){
				this.setState({page:this.state.page}, ()=>{
					this.searchWorkfolio()
				});
			}
		} );

		if(this.state.page>=1){
			document.title=`Directory Search | Page ${this.state.page} | People `
		}
		else{
			document.title="Directory Search | People"
		}
	   }

	}   

	toggleAdvancedSearch(){
		this.setState({advancedOpen: !this.state.advancedOpen});
		console.log(this.state.advancedOpen);
	}

	handlePageChange(event, value){
		event.preventDefault();
		this.setState({page:value}, ()=>{
			this.searchWorkfolio()
		});
	};

	sortByChange(event){
		this.setState({sort_by:event.target.value}, ()=>{
			this.searchWorkfolio()
		});
	}

	onReCAPTCHAClose(){
		this.setState({recaptcha_req: false, recaptcha_display: false, loading: false, keyword:null});
		window.location.reload();
	}

	resetFilters(){
		console.log("reset clicked")
		this.setState({keyword:"", department:"", ucid:"", location:"", phone:""});
		window.history.replaceState(null, null, "?");
	}

	resetDept(){
		this.setState({department:""});
	}
	

  	render() {
		var output="no result";
		if(this.state.data){
			let total = this.state.data.length;
			output = this.state.data.map((d,i) => {
				return(
					<PeopleCard d={d} i={i} total={total} key={i}/>
				);
			} );
		}

		var loading_page = 
			<div className='loading'>
				<br/>
				<div className="la-ball-grid-pulse">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div>
		
		return(
		  <React.Fragment>
			<form onSubmit={this.handleSubmit} className="search-form">
				<div className='search-wrapper'>
					<input
					type="text"
					name="keyword"
					placeholder="Search for a person’s name"
					onChange={this.handleChange} 
					value={this.state.keyword}
					className='search-bar'/>
				</div>
				<AdvancedSearch state={this.state} toggleAdvancedSearch={this.toggleAdvancedSearch} handleChange={this.handleChange} resetFilters={this.resetFilters} resetDept={this.resetDept}/>
			</form>

		  <div className="peopleclient-wrapper">
		  {(this.state.totalResult==0 || this.state.loading)?
				" ":	
			  <div className='result-showing'>
				<div className='member-count-container'>		
				<span id="showing">Showing {(this.state.page-1)*10+1} - {this.state.page*10>this.state.totalResult? this.state.totalResult:this.state.page*10} of {this.state.totalResult} results</span>
				
				</div>

				<div className='sort-container'>
					<label htmlFor="sortBy">Sort By: </label>
					<Select 
						native
						defaultValue={"last_name"}
						onChange={this.sortByChange}
						inputProps={{
						  name: 'sort_by',
						  id: 'uncontrolled-native',
						}}
						>
						<option value="last_name">Last Name</option>
						<option value="first_name">First Name</option>
					</Select>
				</div>
			  </div>

			}

			<ReCAPTCHA_Modal state={this.state} setReCAPTCHAToken={this.setReCAPTCHAToken} onReCAPTCHAClose={this.onReCAPTCHAClose}/>


		      <div className="items">
				{this.state.loading? loading_page : output}
	          </div>

			  <br/>

			  {(this.state.totalResult==0 || this.state.loading)?
				" ":	
				<div className='page-wrapper'>
				<Pagination count={this.state.totalPage} variant="outlined" shape="rounded" color="#bb271a" page={this.state.page} onChange={this.handlePageChange}/>
			   </div>

			}

         </div>

		</React.Fragment>
	    );
  	}
}



PeopleClient.propTypes = {
  category: PropTypes.array,

};

export default PeopleClient;


// WEBPACK FOOTER //
// ./src/PeopleClient/PeopleClient.js